var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOthersIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3310_2773",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 2,
    width: 19,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16602 21.875H19.2702C19.6846 21.875 20.082 21.7104 20.375 21.4174C20.6681 21.1243 20.8327 20.7269 20.8327 20.3125V4.6875C20.8327 4.2731 20.6681 3.87567 20.375 3.58265C20.082 3.28962 19.6846 3.125 19.2702 3.125H8.85352",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4574 18.7501C14.3339 18.7501 16.6657 16.4183 16.6657 13.5417H6.24902C6.24902 16.4183 8.58079 18.7501 11.4574 18.7501Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.33301 9.375V10.4167M11.458 9.375V10.4167M14.583 9.375V10.4167",
    stroke: "white",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3310_2773)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H25V25H0V0Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersIcon);
export default __webpack_public_path__ + "static/media/othersIcon.872fd73744b93527c56d6cb2548949aa.svg";
export { ForwardRef as ReactComponent };